export const extractFilters = (filters: any[]) => {
  const filter: string[] = filters.map((item) => item.filter)
  const filterBy: string[] = filters.map((item) => item.filterBy)
  const filterOperator: string[] = filters.map((item) => item.filterOperator)

  return { filter, filterBy, filterOperator }
}
